const modules = [
  {
    id: "primer",
    image:
      "https://images.unsplash.com/photo-1784334312040-5b3d4cf78b88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHJlcG9ydCUyMGRlc2t8ZW58MHx8fHwxNzkyMDU3NzczfDA&ixlib=rb-4.1.0&q=85",
    alt: "Hand operating a laptop displaying a business data spreadsheet",
    tag: "Primer & Proxy",
    title: "Company Primer & Governance",
    body: "Instant breakdown of revenue models, segment economics, insider ownership, and proxy disclosures.",
  },
  {
    id: "valuation",
    image:
      "https://images.unsplash.com/photo-1651341050677-24dba59ce0fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxzdG9jayUyMG1hcmtldCUyMGdyYXBoc3xlbnwwfHx8fDE3OTIwNTc3NzN8MA&ixlib=rb-4.1.0&q=85",
    alt: "Financial valuation interface with stock market graphs",
    tag: "DCF & Multiples",
    title: "Valuation & Comps Engine",
    body: "Dynamic peer benchmarking, historical multiples, and customizable scenario sensitivity models.",
  },
  {
    id: "social",
    image:
      "https://images.unsplash.com/photo-1625123627242-97ef1000c6d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxwb2RjYXN0JTIwbWljcm9waG9uZSUyMGRlc2t8ZW58MHx8fHwxNzkyMDU3NzczfDA&ixlib=rb-4.1.0&q=85",
    alt: "Podcast microphone on a research desk",
    tag: "Discourse Stream",
    title: "Discourse & Fund Letters",
    body: "Aggregates commentary across hedge fund letters, podcasts, Substack research, and expert transcripts.",
  },
];

export const Modules = () => {
  return (
    <section
      id="modules"
      data-testid="modules-section"
      className="py-24 md:py-32 px-6 lg:px-12 bg-grove-alt border-b border-grove-bsub"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <p className="font-mono text-xs uppercase tracking-widest text-grove-mid mb-2">
            02 / Research Workflows
          </p>
          <h2 className="font-disp text-3xl md:text-5xl text-grove-ink">
            From Ramp-Up to Variant Perception
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {modules.map((mod) => (
            <div
              key={mod.id}
              data-testid={`module-card-${mod.id}`}
              className="bg-white p-8 rounded-xl border border-grove-bsub shadow-sm flex flex-col justify-between hover:shadow-md transition-shadow"
            >
              <div className="h-44 rounded-lg mb-6 overflow-hidden relative border border-grove-cardline">
                <img
                  src={mod.image}
                  alt={mod.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover eq-drift"
                />
                <div className="absolute bottom-3 left-3 bg-black/60 backdrop-blur text-white font-mono text-[10px] px-2 py-0.5 rounded">
                  {mod.tag}
                </div>
              </div>
              <div>
                <h3 className="font-disp text-xl text-grove-ink font-semibold mb-2">
                  {mod.title}
                </h3>
                <p className="text-sm text-grove-mute">{mod.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
